import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/utils';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: 'default' | 'elevated' | 'darker';
}

export function Card({ children, className, variant = 'default', ...rest }: CardProps) {
  const bg =
    variant === 'elevated' ? 'bg-bg-elevated' : variant === 'darker' ? 'bg-bg-darker' : 'bg-bg-card';
  return (
    <div
      className={cn('rounded-xl border border-border-base p-4', bg, className)}
      {...rest}
    >
      {children}
    </div>
  );
}
